"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _index = _interopRequireDefault(require("../index"));
var version = "v1";
var _default = exports["default"] = {
  getProducts: function getProducts(id, subfamily) {
    return _index["default"].get("/".concat(version, "/vendors/arts-entertainment/").concat(subfamily, "/").concat(id, "/infos"));
  },
  getPaymentInfo: function getPaymentInfo(id, subfamily, _ref) {
    var orderId = _ref.orderId,
      transactionId = _ref.transactionId;
    var payload = {
      "transaction-id": transactionId
    };
    return _index["default"].post("/".concat(version, "/vendors/arts-entertainment/").concat(subfamily, "/").concat(id, "/payments/").concat(orderId), payload);
  },
  makeReservation: function makeReservation(id, subfamily, _ref2) {
    var firstname = _ref2.firstname,
      lastname = _ref2.lastname,
      email = _ref2.email,
      orders = _ref2.orders;
    var payload = {
      "first-name": firstname || null,
      "last-name": lastname || null,
      email: email || null,
      orders: orders || []
    };
    return _index["default"].post("/".concat(version, "/vendors/arts-entertainment/").concat(subfamily, "/").concat(id, "/reservations"), payload);
  },
  makePayment: function makePayment(id, subfamily, _ref3) {
    var reservationId = _ref3.reservationId,
      stripeCard = _ref3.stripeCard,
      ingenicoCard = _ref3.ingenicoCard,
      amount = _ref3.amount,
      email = _ref3.email,
      firstname = _ref3.firstname,
      lastname = _ref3.lastname,
      quantity = _ref3.quantity,
      currency = _ref3.currency,
      technicalNotes = _ref3.technicalNotes,
      imageUrl = _ref3.imageUrl,
      subscription = _ref3.subscription,
      browserAcceptHeader = _ref3.browserAcceptHeader,
      browserColorDepth = _ref3.browserColorDepth,
      browserJavaEnabled = _ref3.browserJavaEnabled,
      browserLanguage = _ref3.browserLanguage,
      browserScreenHeight = _ref3.browserScreenHeight,
      browserScreenWidth = _ref3.browserScreenWidth,
      browserTimezone = _ref3.browserTimezone,
      browserUserAgent = _ref3.browserUserAgent,
      cardHolderName = _ref3.cardHolderName;
    var payload = {
      "booking-id": reservationId || null,
      "stripe-card": stripeCard,
      "ingenico-card": ingenicoCard,
      "first-name": firstname || null,
      "last-name": lastname || null,
      email: email || null,
      quantity: quantity || null,
      currency: currency || null,
      amount: amount || null,
      "technical-notes": technicalNotes,
      "image-url": imageUrl,
      subscription: subscription,
      "browser-accept-header": browserAcceptHeader || null,
      "browser-color-depth": browserColorDepth || null,
      "browser-java-enabled": browserJavaEnabled || false,
      "browser-language": browserLanguage || null,
      "browser-screen-height": browserScreenHeight || null,
      "browser-screen-width": browserScreenWidth || null,
      "browser-timezone": browserTimezone || null,
      "browser-user-agent": browserUserAgent || null,
      "card-holder-name": cardHolderName
    };
    return _index["default"].post("/".concat(version, "/vendors/arts-entertainment/").concat(subfamily, "/").concat(id, "/payments"), payload);
  }
};